import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

type Variant = typeof VARIANTS[number];
type Size = typeof SIZES[number];


export default /*@__PURE__*/_defineComponent({
  __name: 'RollingLoader',
  props: {
    variant: { default: "secondary" },
    size: { default: "sm" }
  },
  setup(__props: any) {

const VARIANTS = [
  "primary",
  "secondary",
  "success",
  "danger",
  "warning",
  "info",
  "light",
  "dark"
] as const;

const SIZES = ["sm", "lg"] as const;

const props = __props;

if (!VARIANTS.includes(props.variant)) {
  console.warn(`Invalid variant "${props.variant}", allowed values are: ${VARIANTS.join(', ')}`);
}
if (!SIZES.includes(props.size)) {
  console.warn(`Invalid size "${props.size}", allowed values are: ${SIZES.join(', ')}`);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("output", {
    class: _normalizeClass(`spinner-border spinner-border-${__props.size} text-${__props.variant}`)
  }, null, 2))
}
}

})